import {
    clearSingleDropDownList,
    getDropdownValues,
    getValidateAccountDetails,
    resetSurgeryDetails,
    resetValidateAccountDetails,
} from '../../scheduleSurgery/redux/actions';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
/**
 * Custom hook to fetch Mazor Case Coverage Employees dropdown values when myCaseRefId changes.
 * @param {string} myCaseRefId - The case reference ID.
 * @param {function} dispatch - Redux dispatch function.
 * @param {function} getDropdownValues - Action creator for dropdown values.
 */
export function useMazorCaseCoverageDropdown({ myCaseRefId, dispatch }) {
    useEffectWithErrorLogging(() => {
        const params = {
            sstRef: myCaseRefId,
        };
        params?.sstRef && params?.sstRef.length > 0 && dispatch(
            getDropdownValues({
                dropDownName: 'mazorCaseCoverageEmployees',
                value: params,
            })
        );
    }, [myCaseRefId]);
}
